import PropTypes from 'prop-types';
import React from 'react';

import IfmsButton, { IfmsButtonProps } from './IfmsButton';

const DashboardCustomButton = React.forwardRef<HTMLButtonElement, IfmsButtonProps>(({children, ...other}, ref) => {
  return (
    <IfmsButton ref={ref} {...other} baseClass="ifms-dashboard-custom-button">
      {children}
    </IfmsButton>
  );
});

DashboardCustomButton.defaultProps = {
};

DashboardCustomButton.propTypes = {
  size: PropTypes.oneOf(['regular', 'small', 'large']),
};

export default React.memo(DashboardCustomButton);

